/**
 * Roteiro da ligacao da IA em tres blocos (abertura, objecao, fechamento).
 *
 * E a "previa" do canal de voz: nao ha aparelho para desenhar, entao o que a
 * pessoa precisa ver e a estrutura que a Vapi recebe e a regra que limita o
 * custo -- RF08, teto de 2 ligacoes por lead. A nota fica DENTRO do
 * componente, e nao a cargo de quem o usa, porque todo roteiro de voz deve
 * carrega-la: e a unica coisa que impede alguem de escrever "ligue ate
 * atender" no fechamento.
 */

import { Badge, Icon, Panel, destacarVariaveis } from '../../../components/ui';
import type { VoiceScript } from '../types';

const BLOCOS: readonly { readonly chave: keyof VoiceScript; readonly titulo: string; readonly dica: string }[] = [
  { chave: 'opening', titulo: 'Abertura', dica: 'Quem fala, por que ligou e a pergunta que abre a conversa.' },
  { chave: 'objection', titulo: 'Se o lead objetar', dica: 'Uma linha por objeção: o que a IA pode responder e o que ela não pode prometer.' },
  { chave: 'closing', titulo: 'Fechamento', dica: 'Combina o próximo passo (link no WhatsApp) e encerra.' },
];

const VAZIO = 'Este bloco ainda está vazio.';

export function RoteiroVoz({ script, compacto = false }: { readonly script: VoiceScript; readonly compacto?: boolean }): JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <ol className="flex flex-col gap-3">
        {BLOCOS.map((bloco, i) => {
          const texto = script[bloco.chave];
          return (
            <li key={bloco.chave} className="rounded-2xl border border-line bg-surface p-4 shadow-soft">
              <div className="flex flex-wrap items-center gap-2">
                <span aria-hidden="true" className="grid h-6 w-6 place-items-center rounded-full bg-brand/10 text-xs font-semibold text-brand">
                  {i + 1}
                </span>
                <h3 className="text-sm font-semibold text-ink">{bloco.titulo}</h3>
                {compacto ? null : <span className="text-xs text-ink-subtle">{bloco.dica}</span>}
              </div>
              <p className={`mt-2 whitespace-pre-wrap text-sm leading-relaxed ${texto.trim() === '' ? 'italic text-ink-subtle' : 'text-ink-muted'}`}>
                {texto.trim() === '' ? VAZIO : destacarVariaveis(texto)}
              </p>
            </li>
          );
        })}
      </ol>
      <Panel tone="warning" className="flex items-start gap-3 px-4 py-3">
        <Icon name="telefone" size="sm" className="mt-0.5 shrink-0 text-status-warning" />
        <p className="text-xs text-ink-muted">
          <span className="font-medium text-ink">Teto de 2 ligações por lead (RF08).</span> A IA tenta no máximo duas vezes; caixa postal encerra a tentativa na hora e a
          régua segue para o WhatsApp. O roteiro não pode pedir para insistir nem inventar cupom ou desconto.
        </p>
      </Panel>
      <div className="flex flex-wrap gap-2">
        <Badge tone="neutral" icon="relogio">
          Espera de 30 min após o abandono
        </Badge>
        <Badge tone="neutral" icon="robo">
          Executado pela Vapi
        </Badge>
      </div>
    </div>
  );
}
